// extracted by mini-css-extract-plugin
export default {"container":"styles_container__uOUsU","content":"styles_content__EbPen","open":"styles_open__o45OJ","closed":"styles_closed__WX7z2"};